// Duration unit labels for mentoring and split windows. See ClickUp 868jxkz4p §3.
export const DURATION_UNITS = [
  { id: "days", label: "dias" },
  { id: "weeks", label: "semanas" },
  { id: "months", label: "meses" },
];

export const DURATION_UNIT_LABEL = DURATION_UNITS.reduce(
  (acc, unit) => ({ ...acc, [unit.id]: unit.label }),
  {}
);

// Ready-to-use options for Input.Select in the program editor (§6.2).
export const DURATION_UNIT_OPTIONS = DURATION_UNITS.map((unit) => ({
  label: unit.label,
  value: unit.id,
}));
